import { imageUrl } from "@/config/apiUrl";
import { cn } from "@/helper/HelperFunction";
import classes from "./ProfileComponent.module.css";

const ProfileDetailsComponent = ({ user, variant = "circular", collapsed }) => {
  return (
    <div className={cn(classes.profileMain, collapsed && classes.collapsed)}>
      <div className={classes.profileContainer}>
        <div
          className={cn(
            classes.imageWrapper,
            variant === "circular" && classes.circular
          )}
        >
          <img
            src={imageUrl(user?.image)}
            alt={user?.fullName}
            width={50}
            height={50}
            className={classes.profileImage}
            unoptimized={true}
          />
        </div>
        <div className={classes.profileDetails}>
          <p className={classes.name}>{user?.fullName}</p>
          <span className={classes.email}>{user?.email}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetailsComponent;
